/**
* Team Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'team-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      // if there's more than one Team Grid component on the page
      // then there's ONE filter pair
      // filtering refines the already-sorted-via-backend selection
      // and respects each pre-defined query

      let locationSearch = '';
      let specialty = '';
      let locationSlug = '';
      let specialtyTitle = 'Filter by Category';
      let locationTitle = 'Filter by Location';
      let urlParams = new URLSearchParams( window.location.search );

      const allTeamGrids = document.getElementsByClassName( 'team-grid' );

      if ( urlParams.has( 'location' ) ) {
        locationSlug = urlParams.get( 'location' );
        locationSearch = $( '.tax-term.location[data-location-slug=' + locationSlug + ']' ).data( 'location' );
        locationTitle = $( '.tax-term.location[data-location-slug=' + locationSlug + ']' ).data( 'location-title' );

        fireAjax();
        $( '.tax-select-display.location' ).html( locationTitle );
      }

      $( '.tax-term.location' ).on( 'click', function( e ) {
        locationSlug = $( this ).data( 'location-slug' );
        locationSearch = $( this ).data( 'location' );
        locationTitle = $( this ).data( 'location-title' );

        if ( locationSearch === '' || locationSearch == 'all' ) {
          locationSearch = null;
          window.history.pushState( null, null, window.location.pathname );
        } else {
          window.history.pushState( '', '', `?location=${locationSlug}` );
        }
        fireAjax();
      } );

      $( '.tax-term.specialty' ).on( 'click', function( e ) {
        urlParams = new URLSearchParams( window.location.search );
        locationSlug = urlParams.get( 'location' );
        if ( locationSlug ) {
          locationSearch = $( '.tax-term.location[data-location-slug=' + locationSlug + ']' ).data( 'location' );
          locationTitle = $( '.tax-term.location[data-location-slug=' + locationSlug + ']' ).data( 'location-title' );
        } else {
          locationSearch = $( '.location-cat-child.second-level' ).find( [`data-slug='${locationSlug}'`] ).data( 'location' );
          locationTitle = $( '.location-cat-child.second-level' ).find( [`data-slug='${locationSlug}'`] ).data( 'location-title' );
        }

        specialty = $( this ).data( 'specialty' );
        if ( specialty === '' || specialty == 'all' ) {
          specialty = null;
        }
        specialtyTitle = $( this ).data( 'specialty-title' );
        fireAjax();
      } );

      function fireAjax() {
        for ( let i = 0; i < allTeamGrids.length; i++ ) {
          const theseDocs = $( allTeamGrids[i] ).find( '.js-doc-area' );
          theseDocs.css( {'opacity': '0'} );
          theseDocs.empty();

          const initFilter = allTeamGrids[i].dataset.initFilter;
          const initFilterParams = allTeamGrids[i].dataset.initFilterParams;
          const initTitle = allTeamGrids[i].dataset.initTitle;

          $.ajax( {
            type: 'GET',
            url: site_info.wpApiSettings.ll + 'cpt/filter/specialty',
            data: {
              specialty: specialty,
              location: locationSearch,
              initFilterParams: initFilterParams,
              initFilter: initFilter,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              $( 'body' ).click();
              if ( data.length > 0 ) {
                theseDocs.html( data );
              } else {
                theseDocs.html( '<p class="ll_bios_heading text-center hdg-4 w-full"><span class="text-primary-nomad">No results found.</span></p>' );
              }
              theseDocs.css( {'opacity': '1'} );

              if ( specialtyTitle === 'Our Providers' ) {
                specialtyTitle = 'Filter by Category';
              }
              $( '.tax-select-display.specialty' ).html( specialtyTitle );
              if ( locationTitle === 'Our Locations' ) {
                locationTitle = 'Filter by Location';
              }
              $( '.tax-select-display.location' ).html( locationTitle );
            },
            error: function( data ) {
              theseDocs.html( '<h1 class="ll_bios_heading"><span class="text-primary-nomad">No results</span> found.</h1>' );
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
            },
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-grid', COMPONENT );
} )( app );
